import React, {ReactElement, ReactNode} from "react";
import * as Icon from "../icons";
import {useTranslation} from "react-i18next";

const BenefitCards = () => {
  const {t} = useTranslation();

  const benefitCards = [
    {
      title: t("recipe_details.cta.benefit_cards.first_title"),
      description: t("recipe_details.cta.benefit_cards.first_text"),
      color: "bg-[#FDF8F7]",
      textColor: "text-[#835E47]",
      CardIcon: Icon.Step1,
    },
    {
      title: t("recipe_details.cta.benefit_cards.second_title"),
      description: t("recipe_details.cta.benefit_cards.second_text", {count: 40}),
      color: "bg-[#F1F7FD]",
      textColor: "text-[#49769D]",
      CardIcon: Icon.Step3,
    },
    {
      title: t("recipe_details.cta.benefit_cards.third_title"),
      description: t("recipe_details.cta.benefit_cards.third_text"),
      color: "bg-[#F1FDF2]",
      textColor: "text-[#146748]",
      CardIcon: Icon.Step2,
    },
  ];

  return <div className="grid grid-cols-3 max-sm:min-w-[540px] gap-2">
    {
      benefitCards.map((
          {CardIcon, color, textColor, title, description}) => <BenefitCard
          title={title}
          color={color}
          textColor={textColor}
          description={description}
        >
          <CardIcon className="w-12 h-auto -ml-1" />
        </BenefitCard>,
      )
    }
  </div>;
};

const BenefitCard = ({title, color, textColor, description, children}: {
  title: string,
  color: string,
  textColor: string,
  description: string,
  children: ReactNode
}): ReactElement => <div
  key={title}
  className={`flex flex-col mb-4 rounded-3xl p-4 gap-1 ${color} ${textColor}`}
>
  {children}
  <h3 className={`${textColor}`}>{title}</h3>
  <p className="text-sm leading-5 opacity-70">{description}</p>
</div>;

export {BenefitCards};
